import React from "react";
import "./css/header.css";
import { FiArrowLeft, FiUser } from "react-icons/fi";
import { isMobile } from "../../utils/utils";
import NotificationCenter from "../../notifications/NotificationCenter";


function CryptemberHeader({openSettingsModal, onBackToInsights, isProfile = false, theme, toggleTheme}) {

    const imgParams = !isMobile() ? { width : "200", height: "40" } : { width : "150", height: "30" };

    return (
        <header className="l-header pos_fixed bg_solid">
            <div className="l-subheader at_middle">
                <div className="">
                    <div className="">
                        <div className="">
                            <a className="" href="https://cryptember.com">
                                <img width={imgParams.width} height={imgParams.height} src="https://cryptember.com/wp-content/uploads/logo-2.png"
                                     className="attachment-large size-large" alt=""/>
                                <span className="ripple-container"></span>
                            </a>
                        </div>
                    </div>
                    {/*<div className="l-subheader-cell at_left insights">*/}
                    {/*    Insights*/}
                    {/*</div>*/}
                </div>
            </div>
            <div className="header-account-actions">
                <div className="theme-toggle-container">
                    <span>{theme === 'light' ? 'Light' : 'Dark'}</span>
                    <label className="theme-switch">
                        <input type="checkbox" aria-label="Light theme" checked={theme === 'light'} onChange={toggleTheme} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <NotificationCenter theme={theme}/>
                <button type="button" aria-label={isProfile ? "Back to Insights" : "Open Profile"}
                    className="header-profile-control" onClick={isProfile ? onBackToInsights : openSettingsModal}>
                    {isProfile ? <FiArrowLeft aria-hidden="true" /> : <FiUser aria-hidden="true" />}
                    <span>{isProfile ? "Insights" : "Profile"}</span>
                </button>
            </div>
        </header>
    );
}

export default CryptemberHeader;
